// extracted by mini-css-extract-plugin
export default {"preFormContainer":"styles_preFormContainer__HWbDK","head":"styles_head__77Z2a","closeIcon":"styles_closeIcon__RCG2T"};